import { Color } from '~common/model/basics';
import { getColorCode } from '~web/view/theme/colors';

export const getIconColor = (color: Color | string): string => {
  if (color.startsWith('#') || color.startsWith('rgb')) {
    return color;
  } else {
    return getColorCode(color as Color);
  }
};



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/view/components/ui/icon.helper.ts